export const constants = {
  toggleModal: "feedbackModal/toggleModal",

  sendFeedbackRequest: "feedbackModal/sendFeedbackRequest",
  sendFeedbackSuccess: "feedbackModal/sendFeedbackSuccess",
  sendFeedbackFailure: "feedbackModal/sendFeedbackFailure",
};
